module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cCuHb"))).then(() => parcelRequire('d0iPb'));